import {
    CompositeMetricsGateway,
    Metrics,
    PrometheusMetricsGateway,
    StatsigMetricsGateway,
} from '@/tracking/metrics/metrics.implementations';
import { prometheus } from '@/tracking/prometheus';
import { StatsigEvent } from '@/tracking/statsig/types';

let metrics: Metrics;

export function getMetrics(): Metrics {
    const prometheusGateway = new PrometheusMetricsGateway(prometheus);
    const statsigGateway = new StatsigMetricsGateway();

    const defaultGateway = new CompositeMetricsGateway([prometheusGateway, statsigGateway]);

    if (!metrics) {
        metrics = new Metrics({
            [StatsigEvent.CUSTOM_ERROR]: defaultGateway,
            [StatsigEvent.GENERAL_ERROR]: defaultGateway,
            [StatsigEvent.CHECKOUT_PAGE_INITIATED]: defaultGateway,
        });
    }

    return metrics;
}
